<script>
export let question;
export let answer;
export let id;
</script>

<div class="faq-item mb-md" data-faqid="{id}">
  <h3>
    <a data-toggle="collapse" href="#{id}">{question}
      <svg
        width="16"
        height="11"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2L8 8L2 2"
          stroke="#2751BC"
          stroke-width="3"
          stroke-linecap="round"
        ></path>
      </svg>
    </a>
  </h3>
  <div class="collapse" id="{id}">
    <p>{answer}</p>
  </div>
</div>
